"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Frames = exports.getFrame = void 0;
function getFrame(id) {
    return exports.Frames.find(frame => frame.id === id);
}
exports.getFrame = getFrame;
exports.Frames = [
    {
        id: "black",
        name: "Black",
        color: "#000000",
        thickness: 1.75,
    },
    {
        id: "white",
        name: "White",
        color: "#FFFFFF",
        thickness: 1.75,
    },
    {
        id: "grey",
        name: "grey",
        color: "#A79895",
        thickness: 1.75,
    },
];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRnJhbWVMaWJyYXJ5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvcHJvZHVjdC90YmwvRnJhbWVMaWJyYXJ5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQVNBLFNBQWdCLFFBQVEsQ0FBQyxFQUFVO0lBQ2pDLE9BQU8sY0FBTSxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUMsRUFBRSxDQUFDLEtBQUssQ0FBQyxFQUFFLEtBQUssRUFBRSxDQUFDLENBQUM7QUFDL0MsQ0FBQztBQUZELDRCQUVDO0FBRVksUUFBQSxNQUFNLEdBQWdCO0lBQ2pDO1FBQ0UsRUFBRSxFQUFFLE9BQU87UUFDWCxJQUFJLEVBQUUsT0FBTztRQUNiLEtBQUssRUFBRSxTQUFTO1FBQ2hCLFNBQVMsRUFBRSxJQUFJO0tBQ2hCO0lBQ0Q7UUFDRSxFQUFFLEVBQUUsT0FBTztRQUNYLElBQUksRUFBRSxPQUFPO1FBQ2IsS0FBSyxFQUFFLFNBQVM7UUFDaEIsU0FBUyxFQUFFLElBQUk7S0FDaEI7SUFDRDtRQUNFLEVBQUUsRUFBRSxNQUFNO1FBQ1YsSUFBSSxFQUFFLE1BQU07UUFDWixLQUFLLEVBQUUsU0FBUztRQUNoQixTQUFTLEVBQUUsSUFBSTtLQUNoQjtDQUNGLENBQUMifQ==